export default __webpack_public_path__ + "SKT_lamping_socket-8Rj.svg";